import React, { useState } from 'react';
import Modal from "../../../../components/Modal/Modal";

const ImportacionDeResultados = () => {
  const [statusModal, setModalStatus] = useState(true);
  const [datosModal, setDatosModal] = useState("");
  return (
    <> 
    <Modal
      datos={datosModal}
      isOpen={statusModal}
      onClose={() => setModalStatus(false)}
      type={"importacionResultados"}
    />
    </>
  )
}

export default ImportacionDeResultados